import styled from 'styled-components';

export const ActivitiesReport = styled.div`
  background: white;
  min-height: 100%;
`
